import { createFileRoute } from '@tanstack/react-router';
import { ReleaseNotesListView } from '@/features/release-notes/ReleaseNotesListView';

function ReleaseNotesRoute() {
  const { asUser } = Route.useSearch();
  return <ReleaseNotesListView asUser={asUser} />;
}

export const Route = createFileRoute('/release-notes/')({
  validateSearch: (raw: Record<string, unknown>): { asUser?: string } => ({
    asUser: typeof raw.asUser === 'string' && raw.asUser ? raw.asUser : undefined
  }),
  component: ReleaseNotesRoute
});
